// extracted by mini-css-extract-plugin
export default {"infoContainer":"styles_infoContainer__v+nU+","infoIcon":"styles_infoIcon__TUE9N","infoData":"styles_infoData__Dv6SZ","dailyDataBtn":"styles_dailyDataBtn__b9f-0"};